import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, getDocs, limit } from 'firebase/firestore';
// import Swal from 'sweetalert2';
import { doc, updateDoc } from 'firebase/firestore';
import { DB } from '~/services/firebase';

import Admin from '~/layouts/Admin';
import IPayment from '~/interfaces/IPayment';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import { MONTHS } from '~/utils/getEnums';
import { useToast } from '~/hooks/toast';

const Payments: React.FC = () => {
  const { addToast } = useToast();
  const [payments, setPayments] = useState<IPayment[]>([]);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('Todos');
  const [showFilter, setShowFilter] = useState(false);

  const load = useCallback(async () => {
    const q = query(collection(DB, 'payments'), limit(100));
    const querySnapshot = await getDocs(q);

    const items: IPayment[] = [];

    querySnapshot.docs.forEach(item => {
      const parseItem = {
        ...item.data(),
        uid: item.id,
      } as IPayment;

      items.push(parseItem);
    });

    setPayments(items);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const filteredCompanies = useMemo(() => {
    const filtered = payments.filter(payment => {
      let result = true;

      if (status === 'Ativo') {
        result =
          payment.company_name
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) && payment.status === true;
      } else if (status === 'Inativo') {
        result =
          payment.company_name
            .toLocaleLowerCase()
            .includes(search.toLocaleLowerCase()) && payment.status === false;
      } else {
        result = payment.company_name
          .toLocaleLowerCase()
          .includes(search.toLocaleLowerCase());
      }

      return result;
    });
    return filtered;
  }, [search, payments, status]);

  const handleChangeStatus = useCallback(
    async (payment_id: string, payment_status: boolean) => {
      const items = [...payments];

      const findIndex = items.findIndex(item => item.uid === payment_id);

      if (findIndex !== -1) {
        await updateDoc(doc(DB, 'payments', payment_id), {
          status: payment_status,
        });

        items[findIndex] = {
          ...items[findIndex],
          status: payment_status,
        };

        setPayments(items);
      }

      addToast({
        type: 'success',
        description: 'O pagamento foi atualizado com sucesso!',
      });
    },
    [addToast, payments],
  );

  // const handleConfirmRemove = useCallback(
  //   async (id: string) => {
  //     const { isConfirmed } = await Swal.fire({
  //       title: 'Atenção!',
  //       text: 'Confirme a exclusão da categoria?',
  //       icon: 'warning',
  //       confirmButtonText: 'Sim',
  //       showCancelButton: true,
  //       cancelButtonText: 'Não',
  //     });

  //     if (isConfirmed) {
  //       await deleteDoc(doc(DB, 'categories', id));

  //       loadCategories();

  //       addToast({
  //         type: 'success',
  //         description: 'Categoria foi removida com sucesso.',
  //       });
  //     }
  //   },
  //   [addToast, loadCategories],
  // );

  return (
    <Admin>
      <div className="col-xl-8 offset-xl-2">
        <div className="nk-block-head nk-block-head-sm">
          <div className="nk-block-between">
            <div className="nk-block-head-content">
              <h3 className="nk-block-title page-title">Pagamentos</h3>
            </div>
            <div className="nk-block-head-content">
              <div className="toggle-wrap nk-block-tools-toggle">
                <button
                  type="button"
                  className={`btn btn-icon btn-trigger toggle-expand mr-n1 ${
                    showFilter && 'active'
                  }`}
                  data-target="pageMenu"
                  onClick={() => setShowFilter(current => !current)}
                >
                  <em className="icon ni ni-more-v" />
                </button>
                <div
                  className={`toggle-expand-content ${
                    showFilter && 'expanded'
                  }`}
                  data-content="pageMenu"
                >
                  <ul className="nk-block-tools g-3">
                    <li>
                      <div className="form-control-wrap">
                        <div className="form-icon form-icon-right">
                          <em className="icon ni ni-search" />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="default-04"
                          placeholder="Buscar por estabelecimento"
                          onChange={event => {
                            setSearch(event.target.value);
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="drodown">
                        <Link
                          to="#status"
                          className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                          data-toggle="dropdown"
                        >
                          {status}
                        </Link>
                        <div className="dropdown-menu dropdown-menu-right">
                          <ul className="link-list-opt no-bdr">
                            <li>
                              <Link
                                to="#status"
                                onClick={() => setStatus('Todos')}
                              >
                                <span>Todos</span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#pago"
                                onClick={() => setStatus('Pago')}
                              >
                                <span>Pago</span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#reprovado"
                                onClick={() => setStatus('Reprovado')}
                              >
                                <span>Reprovado</span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#pendente"
                                onClick={() => setStatus('Pendente')}
                              >
                                <span>Pendente</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    {/* <li className="nk-block-tools-opt">
                      <Link
                        to="/companies/create"
                        data-target="addProduct"
                        className="toggle btn btn-icon btn-primary d-md-none"
                      >
                        <em className="icon ni ni-plus" />
                      </Link>
                      <Link
                        to="/companies/create"
                        data-target="addProduct"
                        className="toggle btn btn-primary d-none d-md-inline-flex"
                      >
                        <em className="icon ni ni-plus" />
                        <span>Cadastrar</span>
                      </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="nk-block">
          <div className="card card-bordered">
            <div className="card-inner-group">
              <div className="card-inner p-0">
                <div className="nk-tb-list">
                  <div className="nk-tb-item nk-tb-head">
                    <div className="nk-tb-col">
                      <span>Cliente</span>
                    </div>
                    <div className="nk-tb-col">
                      <span>Valor</span>
                    </div>
                    <div className="nk-tb-col">
                      <span>Status</span>
                    </div>

                    <div className="nk-tb-col nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1 my-n1">
                        <li className="mr-n1" />
                      </ul>
                    </div>
                  </div>

                  {filteredCompanies.map(item => (
                    <div className="nk-tb-item" key={item.uid}>
                      <div className="nk-tb-col">
                        <a
                          href={item.image}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <span className="tb-product">
                            <span className="title">{item.company_name}</span>
                          </span>
                          {`${MONTHS[item.month]}/${item.year}`}
                        </a>
                      </div>

                      <div className="nk-tb-col">
                        <div className="asterisk tb-asterisk">
                          <span className="title fs-12px">
                            {getCurrencyFormatted(item.value)}
                          </span>
                        </div>
                      </div>

                      <div className="nk-tb-col">
                        <div className="asterisk tb-asterisk">
                          <span
                            className={`text-${
                              item.status
                                ? 'success'
                                : item.status === null
                                ? 'warning'
                                : 'danger'
                            } fs-12px`}
                          >
                            {item.status && <span>Pago</span>}
                            {item.status === null && <span>Pendente</span>}
                            {item.status !== null && !item.status && (
                              <span>Reprovado</span>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="nk-tb-col nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1 my-n1">
                          <li className="mr-n1">
                            <button
                              type="button"
                              className="btn btn-dim btn-sm btn-success ml-1"
                              onClick={() => handleChangeStatus(item.uid, true)}
                            >
                              <em className="icon ni ni-check-circle-cut" />
                            </button>
                            <button
                              type="button"
                              className="btn btn-dim btn-sm btn-danger ml-1"
                              onClick={() =>
                                handleChangeStatus(item.uid, false)
                              }
                            >
                              <em className="icon ni ni-cross-round" />
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Admin>
  );
};

export default Payments;
